import {graphql, useStaticQuery} from "gatsby";const useIndexData = () => {
  const data = useStaticQuery(
      graphql`
        query{
        coronas: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#COVID_19"}}}}) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        reports: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#data_reports"}}}}) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        featuredUpdate: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#klear_updates"}}}, tags: {elemMatch: {name: {eq: "featured"}}}}, limit: 1) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        products: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#klear_updates"}}}}) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        strategies: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#strategy"}}}, tags: {elemMatch: {name: {ne: "featured"}}}}) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        featuredStrategy: allWordpressPost(sort: {fields: [date], order: [DESC]}, filter: {categories: {elemMatch: {name: {eq: "#strategy"}}}, tags: {elemMatch: {name: {eq: "featured"}}}}, limit: 1) {
          edges {
            node {
              date(formatString: "MMMM DD, YYYY")
              title
              slug
              excerpt
              featured_media {
                source_url
              }
              author {
                name
              }
              categories {
                name
                slug
              }
            }
          }
        }
        allBlogPosts: allWordpressPost(sort: {fields: [date], order: [DESC]}) {
          totalCount
          edges {
              node {
                  date(formatString: "MMMM DD, YYYY")
                  title
                  slug
                  excerpt
                  featured_media {
                      source_url
                  }
                  author {
                      name
                  }
                  categories {
                      name
                      slug
                  }
              }
          }
        }
      }
  `);
  return data;
};

export default useIndexData;